class LACollectionList extends HTMLElement {
    constructor() {
        super();
        this.list = this.querySelector('.la-cl-list');
        this.prevButton = this.querySelector('.swiper-button-prev');
        this.nextButton = this.querySelector('.swiper-button-next');

        if (this.prevButton && this.nextButton && this.list) {
            this.init();
        }
    }

    init() {
        // Scroll amount (adjust as needed)
        const scrollAmount = 400;

        // Previous button click
        this.prevButton.addEventListener('click', () => {
            this.list.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });

        // Next button click
        this.nextButton.addEventListener('click', () => {
            this.list.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });

        // Update button states on scroll
        this.list.addEventListener('scroll', () => {
            this.updateButtonStates();
        });

        // Initial button state
        this.updateButtonStates();
    }

    updateButtonStates() {
        const scrollLeft = this.list.scrollLeft;
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;

        // Disable prev button at start
        if (scrollLeft <= 0) {
            this.prevButton.setAttribute('disabled', '');
            this.prevButton.style.opacity = '0.3';
        } else {
            this.prevButton.removeAttribute('disabled');
            this.prevButton.style.opacity = '1';
        }

        // Disable next button at end
        if (scrollLeft >= maxScroll - 1) {
            this.nextButton.setAttribute('disabled', '');
            this.nextButton.style.opacity = '0.3';
        } else {
            this.nextButton.removeAttribute('disabled');
            this.nextButton.style.opacity = '1';
        }
    }
}

customElements.define('la-collection-list', LACollectionList);
